module.exports = __webpack_public_path__ + "static/image-chris-cd47126470946a151ad60709182d20c8.svg";